var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41425 3.72139H15.4102C17.3892 3.72139 19.0002 5.40458 19.0002 7.47374V10.1011C19.0002 10.6891 18.5532 11.1644 18.0002 11.1644C17.4473 11.1644 17.0002 10.6891 17.0002 10.1011V7.47374C17.0002 6.57845 16.2873 5.84797 15.4102 5.84797H3.41425L4.70725 7.22281C5.09725 7.63855 5.09725 8.31055 4.70725 8.7263C4.51225 8.93364 4.25625 9.03784 4.00025 9.03784C3.74425 9.03784 3.48825 8.93364 3.29325 8.7263L0.29325 5.53643C-0.09775 5.12068 -0.09775 4.44868 0.29325 4.03293L3.29325 0.84306C3.68325 0.427313 4.31625 0.427313 4.70725 0.84306C5.09725 1.25881 5.09725 1.93081 4.70725 2.34655L3.41425 3.72139ZM14.293 13.6028C14.684 13.1871 15.316 13.1871 15.707 13.6028L18.707 16.7927C19.098 17.2084 19.098 17.8804 18.707 18.2962L15.707 21.486C15.512 21.6934 15.256 21.7976 15 21.7976C14.744 21.7976 14.488 21.6934 14.293 21.486C13.902 21.0703 13.902 20.3983 14.293 19.9826L15.586 18.6077H3.59C1.61 18.6077 6.70552e-08 16.9245 6.70552e-08 14.8554V12.228C6.70552e-08 11.64 0.448 11.1647 1 11.1647C1.552 11.1647 2 11.64 2 12.228V14.8554C2 15.7517 2.713 16.4811 3.59 16.4811H15.586L14.293 15.1063C13.902 14.6906 13.902 14.0186 14.293 13.6028Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvert);
export default __webpack_public_path__ + "static/media/convert.e090e856917a8ad15c4efe778460efa1.svg";
export { ForwardRef as ReactComponent };